"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryKeys = exports["default"] = void 0;

var _reactQuery = require("react-query");

var _filterUtils = require("@nicbase/filter-utils");

var _request = require("@nicbase/request");

var _types = require("@nicbase/types");

var _portalAdminQueryKey = _interopRequireDefault(require("./portalAdminQueryKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var attributeMapping = {
  id: 'poi.id',
  name: 'poi.name',
  type: 'poi.type',
  portalId: 'poi.portalId',
  categoryId: 'poi.categoryId',
  categoryName: 'poi.categoryName',
  icon: 'poi.categoryIcon',
  externalId: 'poi.externalId'
};
var queryKeys = {
  all: function all(portalId) {
    return [].concat(_toConsumableArray((0, _portalAdminQueryKey["default"])(portalId)), ['pois']);
  }
};
exports.queryKeys = queryKeys;

var usePortalAdminPois = function usePortalAdminPois() {
  var requestParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var queryOptions = arguments.length > 1 ? arguments[1] : undefined;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var filters = requestParams.filters,
      _requestParams$pageSi = requestParams.pageSize,
      pageSize = _requestParams$pageSi === void 0 ? null : _requestParams$pageSi,
      _requestParams$sortin = requestParams.sorting;
  _requestParams$sortin = _requestParams$sortin === void 0 ? {} : _requestParams$sortin;
  var _requestParams$sortin2 = _requestParams$sortin.sortBy,
      sortBy = _requestParams$sortin2 === void 0 ? 'id' : _requestParams$sortin2,
      _requestParams$sortin3 = _requestParams$sortin.sortDirection,
      sortDirection = _requestParams$sortin3 === void 0 ? 'ASC' : _requestParams$sortin3;

  var _ref = filters !== null && filters !== void 0 ? filters : {},
      portalId = _ref.portalId,
      id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      categoryId = _ref.categoryId,
      categoryName = _ref.categoryName,
      categoryTypes = _ref.categoryTypes,
      externalId = _ref.externalId;

  return (0, _reactQuery.useInfiniteQuery)([].concat(_toConsumableArray(queryKeys.all(portalId)), [requestParams]), /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var _ref2$pageParam, pageNumber, pagination, _and, filterTree, _yield$request, _yield$request$body, pois, filteredCount;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$pageParam = _ref2.pageParam, pageNumber = _ref2$pageParam === void 0 ? 0 : _ref2$pageParam;

              if (pageSize) {
                pagination = {
                  pageNumber: pageNumber,
                  pageSize: pageSize
                };
              }

              _and = (0, _filterUtils.and)((0, _filterUtils.equal)(attributeMapping.portalId, portalId, _types.FilterAttributeType.Integer), (0, _filterUtils.equal)(attributeMapping.id, id, _types.FilterAttributeType.Integer), (0, _filterUtils.like)(attributeMapping.name, name, _types.FilterAttributeType.String), (0, _filterUtils.equal)(attributeMapping.type, type, _types.FilterAttributeType.String), (0, _filterUtils.equal)(attributeMapping.categoryId, categoryId, _types.FilterAttributeType.Integer), (0, _filterUtils.like)(attributeMapping.categoryName, categoryName, _types.FilterAttributeType.String), (0, _filterUtils.isIn)(attributeMapping.icon, categoryTypes, _types.FilterAttributeType.String), (0, _filterUtils.like)(attributeMapping.externalId, externalId, _types.FilterAttributeType.String)), filterTree = _and.filterTree;
              _context.next = 5;
              return request({
                type: 'FIND_POIS_REQUEST',
                headers: {
                  portalId: portalId,
                  version: 'v1'
                },
                body: {
                  dynamicFilters: filterTree,
                  dynamicSorters: [{
                    attributeName: attributeMapping[sortBy],
                    sortOrder: sortDirection
                  }],
                  dynamicPaging: pagination
                }
              });

            case 5:
              _yield$request = _context.sent;
              _yield$request$body = _yield$request.body;
              pois = _yield$request$body.pois;
              filteredCount = _yield$request$body.filteredCount;
              return _context.abrupt("return", {
                pois: pois,
                filteredCount: filteredCount
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), _objectSpread({
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      if (pageSize === null || (lastPage === null || lastPage === void 0 ? void 0 : lastPage.pois.length) < pageSize) {
        return undefined;
      }

      return allPages.length;
    }
  }, queryOptions));
};

var _default = usePortalAdminPois;
exports["default"] = _default;